module.exports = [
  {
    jina_la_kwanza: "Rosalia",
    jina_la_mwisho: "Richard",
    email: "hassanbaruti@yahoo.com",
    phone: "0657691346",
    nida_id: "19650709-52521-45430-92",
    kabila: "Mndali",
    bank: "Tanzania Womenâ Bank",
    company_name: "Spedag Interfreight (T) Ltd",
    started_on: "2020-02-22",
    exited_on: "2022-02-28",
  },
  {
    jina_la_kwanza: "Editha",
    jina_la_mwisho: "Kanzu",
    email: "sallyrichard@ewura.go.tz",
    phone: "0753872567",
    nida_id: "19560506-47714-84686-99",
    kabila: "Mvidunda",
    bank: "Stanbic Bank Tanzania Limited",
    company_name: "Nimeta Consult (T) Ltd",
    started_on: "2020-04-20",
    exited_on: "2021-11-23",
  },
  {
    jina_la_kwanza: "Neema",
    jina_la_mwisho: "Nassor",
    email: "kaggwajohn@tamisemi.go.tz",
    phone: "0745381787",
    nida_id: "19910515-38720-46342-57",
    kabila: "Mtumbuka",
    bank: "Nic Bank Tanzania",
    company_name: "Meru Spring Water Ltd",
    started_on: "2020-07-06",
    exited_on: "2021-08-18",
  },
  {
    jina_la_kwanza: "Celvin",
    jina_la_mwisho: "Richard",
    email: "sheilajoshua@tamisemi.go.tz",
    phone: "0724314144",
    nida_id: "19720425-53184-38107-10",
    kabila: "Mmpoto",
    bank: "Peoples Bank Of Zanzibar",
    company_name: "Chloride Exide Tanzania Ltd",
    started_on: "2019-11-04",
    exited_on: "2021-09-30",
  },
  {
    jina_la_kwanza: "Michael",
    jina_la_mwisho: "Matiku",
    email: "pettyfadhil@ewura.go.tz",
    phone: "0741743693",
    nida_id: "19880911-85107-18358-20",
    kabila: "Mmanda",
    bank: "Finca Microfinance Bank",
    company_name: "Meru Spring Water Ltd",
    started_on: "2019-02-12",
    exited_on: "2021-10-03",
  },
  {
    jina_la_kwanza: "Gabriel",
    jina_la_mwisho: "Jackson",
    email: "monicamwaulanga@yahoo.com",
    phone: "0784700652",
    nida_id: "19710206-50435-83608-62",
    kabila: "Mgweno",
    bank: "National Bank Of Commerce ",
    company_name: "Green Waste Pro Ltd",
    started_on: "2019-10-15",
    exited_on: "2022-10-21",
  },
  {
    jina_la_kwanza: "Suby",
    jina_la_mwisho: "Mohammed",
    email: "johnamani@tamisemi.go.tz",
    phone: "0692079902",
    nida_id: "19570306-46139-23614-53",
    kabila: "Mhutu",
    bank: "Peoples Bank Of Zanzibar",
    company_name: "Citi One Ltd",
    started_on: "2019-07-23",
    exited_on: "2022-09-06",
  },
  {
    jina_la_kwanza: "Farha",
    jina_la_mwisho: "Samwel",
    email: "raiderkaijage@maji.go.tz",
    phone: "0789146391",
    nida_id: "19940828-49431-51329-15",
    kabila: "Makiek",
    bank: "I&M Bank ",
    company_name: "Meru Spring Water Ltd",
    started_on: "2020-05-03",
    exited_on: "2022-09-03",
  },
  {
    jina_la_kwanza: "Clara",
    jina_la_mwisho: "Amani",
    email: "lauramoses@yahoo.com",
    phone: "0724210552",
    nida_id: "19520316-85789-87838-48",
    kabila: "Miraqw",
    bank: "I&M Bank ",
    company_name: "H. Ladwa Ltd",
    started_on: "2020-10-01",
    exited_on: "2022-06-15",
  },
  {
    jina_la_kwanza: "Stanslaus",
    jina_la_mwisho: "Baraka",
    email: "galosipombe@tamisemi.go.tz",
    phone: "0768791287",
    nida_id: "19630726-23214-53370-91",
    kabila: "Mvidunda",
    bank: "Akiba Commercial Bank",
    company_name: "Sign Industries Ltd",
    started_on: "2021-03-21",
    exited_on: "2022-05-26",
  },
];
